import { memo, useEffect, useRef, useState } from 'react';

import { type CustomToastContainerProps } from './ToastProvider';

export type CustomToastItemProps = CustomToastContainerProps;

export const CustomToastItem = memo(({ children, onDismiss, timeBeforeAutoDismiss, type }: CustomToastItemProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const onDismissRef = useRef<CustomToastItemProps['onDismiss']>();
  onDismissRef.current = onDismiss;

  useEffect(() => {
    let timer = 0;

    if (timeBeforeAutoDismiss !== null && timeBeforeAutoDismiss !== undefined && !isHovered && onDismissRef.current) {
      timer = window.setTimeout(onDismissRef.current, timeBeforeAutoDismiss);
    }

    return () => clearTimeout(timer);
  }, [isHovered, timeBeforeAutoDismiss]);

  return (
    <div
      className="my-1"
      data-testid="CUSTOM_TOAST_ITEM"
      onPointerEnter={() => setIsHovered(true)}
      onPointerLeave={() => setIsHovered(false)}
      role={type === 'assertive' ? 'alert' : 'status'}
    >
      {children}
    </div>
  );
});

CustomToastItem.displayName = 'CustomToastItem';
